export const STATUS_LABELS: Record<string, string> = {
  pending: "Autorización Cobranza",
  pending_pricing: "Autorización por Precio",
  pending_credit: "Crédito Insuficiente",
  accepted: "Aprobada",
  prepaid: "Anticipado Pdte Pago",
  payment_to_check: "Validación de Pago",
  por_facturar: "Por Facturar",
  facturado: "Facturado",
  dispatch_ready: "Listo para Despacho",
  in_transit: "En Tránsito",
  delivered: "Entregado",
  rejected: "Rechazada",
  cancelled: "Cancelada",
  test: "Test",
};

const STATUS_DOT_COLORS: Record<string, string> = {
  pending: "bg-amber-500",
  pending_pricing: "bg-yellow-500",
  pending_credit: "bg-orange-500",
  prepaid: "bg-cyan-500",
  payment_to_check: "bg-sky-500",
  accepted: "bg-green-500",
  rejected: "bg-red-500",
  cancelled: "bg-rose-500",
  facturado: "bg-indigo-500",
  por_facturar: "bg-violet-500",
  dispatch_ready: "bg-teal-500",
  in_transit: "bg-blue-500",
  delivered: "bg-purple-500",
  test: "bg-slate-500",
};

const STATUS_TEXT_COLORS: Record<string, string> = {
  accepted: "text-green-600",
  rejected: "text-red-600",
  pending: "text-amber-600",
  prepaid: "text-orange-600",
  delivered: "text-blue-600",
};

/**
 * Spanish label for a sales-request status slug. Unknown slugs are humanized
 * ("foo_bar" -> "Foo bar") so a raw slug never reaches the UI.
 */
export const getStatusLabel = (status: string): string =>
  STATUS_LABELS[status] ??
  status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ");

/** Tailwind background class for a status dot (e.g. "bg-violet-500"). */
export const getStatusDotColor = (status: string): string =>
  STATUS_DOT_COLORS[status] ?? "bg-gray-400";

/** Tailwind text class for inline status text. */
export const getStatusTextColor = (status: string): string =>
  STATUS_TEXT_COLORS[status] ?? "text-gray-600";
